import { z } from 'zod'
import { parseDataOfType } from '@/common/parseDataType'
import { apiErrorHandler } from '../errorHandler'

export const OrgUserSchema = z.object({
  UserID: z.number(),
  FirstName: z.string(),
  Surname: z.string().nullable(),
  Email: z.string(),
  Enabled: z.boolean(),
  Owner: z.boolean(),
  Admin: z.boolean(),
  LastLoggedIn: z.string().nullable()
})

export const GetOrgUsersResponseSchema = z.array(OrgUserSchema).describe('GetOrgUsersResponse')

export type OrgUser = z.infer<typeof OrgUserSchema>

export async function getOrgUsers(): Promise<Array<OrgUser>> {
  const res = await fetch(`${window.location.origin}/api/user/orgUsers`, {
    method: 'GET',
    credentials: 'same-origin'
  })
  await apiErrorHandler(res)
  return parseDataOfType(await res.json(), GetOrgUsersResponseSchema)
}

export const InviteUserRequestSchema = z
  .object({
    email: z.email('Please enter a valid email address'),
    first_name: z.string().min(2, 'Please provide a valid first name'),
    surname: z.string().min(2, 'Please provide a valid surname').optional()
  })
  .describe('InviteUserRequest')

export type InviteUserRequest = z.infer<typeof InviteUserRequestSchema>

export async function inviteUser(req: InviteUserRequest): Promise<void> {
  const validatedReq = parseDataOfType(req, InviteUserRequestSchema)
  const res = await fetch(`${window.location.origin}/api/user/invite`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(validatedReq)
  })
  await apiErrorHandler(res)
}

export const RemoveUserRequestSchema = z.object({ userId: z.number() }).describe('RemoveUserRequest')

export type RemoveUserRequest = z.infer<typeof RemoveUserRequestSchema>

export async function removeUser(req: RemoveUserRequest): Promise<void> {
  const validatedReq = parseDataOfType(req, RemoveUserRequestSchema)
  const res = await fetch(`${window.location.origin}/api/user/${validatedReq.userId}`, {
    method: 'DELETE',
    credentials: 'same-origin'
  })
  await apiErrorHandler(res)
}
